import { useTestDiagnostic } from '@hooks/register/use-test-diagnostic';

export const TestDiagnostic = () => {
    const { model, isLoading, error } = useTestDiagnostic();

    if (isLoading) {
        return (
            <div className="row">
                <div className="col-xs-12">Loading&hellip;</div>
            </div>
        );
    }

    const fields: { label: string; value: string | number | null }[] = [
        { label: 'Registration Id', value: model.registrationId },
        { label: 'Source', value: model.source },
        { label: 'ReferralSource', value: model.referralSource },
        { label: 'EntryDomain', value: model.entryDomain },
        { label: 'EntryQuery', value: model.entryQuery },
        { label: 'EntryReferrer (Id)', value: model.entryReferrerId },
        { label: 'EntryReferrer', value: model.entryReferrer },
    ];

    return (
        <div className='container'>
            <div className="row">
                <div className="col-xs-12">
                    <h1>Test Diagnostic</h1>

                    {error ? (
                        <div className="alert alert-danger">{error}</div>
                    ) : (
                        <table className="table table-bordered table-condensed">
                            <tbody>
                                {fields.map(({ label, value }) => (
                                    <tr key={label}>
                                        <th style={{ width: 200 }}>{label}</th>
                                        <td style={{ wordBreak: 'break-all' }}>{value ?? <em>(null)</em>}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
};
